import CollectionUpdateCover from "./collection-update-cover";

export default CollectionUpdateCover;